const Translations = {
    cs: {
        ask: 'Zeptej se...',
        processing: 'Zpracovávám...',
        error: 'Došlo k chybě! Zkus založit novou konverzaci.',
        password: 'Heslo',
        password_required: 'Zadejte heslo od učitele:',
        responding: 'Copilot právě odpovídá...',
        nickname_required: 'Napiš svou přezdívku.',
        nickname: 'Přezdívka',
        welcome: 'Ahoj! Jak ti mohu pomoci s tvým projektem ve Scratchi? Potřebuješ poradit s něčím konkrétním?',
        access_request: 'Žádosti o zpřístupnění chatbota pro Scratch posílejte na cau@aidetem.cz .'
    },
    en: {
        ask: 'Ask...',
        processing: 'Processing...',
        error: 'An error as occured! Try initiating a new conversation.',
        password: 'Password',
        password_required: 'Enter the password provided by your teacher:',
        responding: 'Copilot is responding now...',
        nickname_required: 'What is your nickname?',
        nickname: 'Nickname',
        welcome: 'Hi there! How can I help you with your Scratch project? ' +
            'Do you need advice on something specific? I\'m here to help!',
        access_request: 'Please send requests for access to the Scratch chatbot to cau@aidetem.cz .'
    }
};
export default Translations;
